;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('CardCompanyPlansController', CardCompanyPlansController)

  /* @ngInject */
  function CardCompanyPlansController (
    $scope,
    $rootScope,
    $translate,
    $q,
    $window,
    AdminService,
    SegmentService,
    BillingService,
    ToastService,
    UdsModalService
  ) {
    const getPlanUpgradeConfirmationDialogController = () => $q.when(import('../../dialogs/plan-upgrade-confirmation/plan-upgrade-confirmation-dialog.controller'))

    $scope.deskfyPlansInfoUrl = 'https://deskfy.io/planos/#comparacao-de-planos'

    $scope.companyPlan = {
      id: 0,
      name: ''
    }

    $scope.companyPackage = {
      id: 0,
      name: ''
    }

    $scope.starterPlan = {
      isRecommended: false,
      isCurrent: false
    }

    $scope.proPlan = {
      isRecommended: false,
      isCurrent: false
    }

    $scope.enterprisePlan = {
      isRecommended: false,
      isCurrent: false
    }

    $scope.flags = {
      loading: false,
      buttonLoading: false
    }

    const api = {
      getPlanUpgradeConfirmationDialogController,
      _triggerViewSegmentEvent,
      _setPlanRecommendations,
      _successPlanInterestEmail,
      _errorPlanInterestEmail,
      _successSendInterestEmail,
      _errorSendInterestEmail,
      _finallySendInterestEmail,
      _openConfirmationDialog,
      _loadCompanyPlanInformation,
      _successLoadCompanyPlanInformation,
      _errorLoadCompanyPlanInformation,
      _finallyLoadCompanyPlanInformation
    }
    this.getApi = () => api

    activate()

    function activate () {
      if ($scope.type === 'MODAL') {
        api._loadCompanyPlanInformation($rootScope.oUser)
      } else {
        $scope.flags.loading = true
        $rootScope.getUser().then(api._loadCompanyPlanInformation)
      }
    }

    $scope.sendPricingInterest = (planInterestId) => {
      $scope.flags.buttonLoading = true

      BillingService.getPlanById(planInterestId)
        .then(api._successPlanInterestEmail)
        .catch(api._errorPlanInterestEmail)
    }

    function _successPlanInterestEmail (plan) {
      const features = {
        triggerFeature: $scope.data?.featureName || '',
        triggerFeatureSlug: $scope.data?.featureSlug || ''
      }

      const options = {
        ...features,
        targetPlanName: plan.name,
        url: $window.location.href
      }

      BillingService.sendInterestEmail(options)
        .then(() => api._successSendInterestEmail(plan, features))
        .catch(api._errorSendInterestEmail)
        .finally(api._finallySendInterestEmail)
    }

    function _errorPlanInterestEmail (error) {
      ToastService.defaultErrorToast()

      if ($scope.data) {
        $scope.onClose({ isError: true })
      }

      console.error({ error })
    }

    function _successSendInterestEmail (plan, features) {
      if ($scope.data) {
        $scope.onClose({ hasInterest: true })
      }

      api._openConfirmationDialog(plan, features)
    }

    function _errorSendInterestEmail (error) {
      ToastService.showErrorToast($translate.instant('planUpgradeDialog.emailError'))
      $scope.onClose({ isError: true })
      console.error({ error })
    }

    function _finallySendInterestEmail () {
      $scope.flags.buttonLoading = false
    }

    function _openConfirmationDialog (plan, features) {
      api.getPlanUpgradeConfirmationDialogController().then(({ PlanUpgradeConfirmationDialogController }) => {
        const planUpgradeConfirmationDialog = UdsModalService.createModal({
          controller: PlanUpgradeConfirmationDialogController,
          modalName: 'planUpgradeConfirmationDialog',
          data: {
            ...features,
            plan,
            companyPlan: $scope.companyPlan,
            companyPackage: $scope.companyPackage
          }
        })

        planUpgradeConfirmationDialog.open()
      })
    }

    function _triggerViewSegmentEvent () {
      const promises = [
        BillingService.getPricingPackageById($scope.companyPackage.id),
        BillingService.getPlanById($scope.companyPlan.id)
      ]

      $q.all(promises).then(([pkg, plan]) => {
        $scope.companyPackage.name = pkg.name
        $scope.companyPlan.name = plan.name

        SegmentService.track('pricing-plansfriction-view', {
          feature_name: $scope.data?.featureName || '',
          feature_slug: $scope.data?.featureSlug || '',
          pricing_plan_actual: `${$scope.companyPlan.id}-${$scope.companyPlan.name}`,
          pricing_package_actual: `${$scope.companyPackage.id}-${$scope.companyPackage.name}`,
          location: $window.location.href
        })
      })
    }

    function _setPlanRecommendations () {
      if ($scope.companyPlan.id === 1) {
        $scope.starterPlan.isCurrent = true
        $scope.proPlan.isRecommended = true
      }

      if ($scope.companyPlan.id === 2) {
        $scope.proPlan.isCurrent = true
        $scope.enterprisePlan.isRecommended = true
      }

      if ($scope.companyPlan.id === 3) {
        $scope.enterprisePlan.isCurrent = true
      }
    }

    function _loadCompanyPlanInformation (user) {
      AdminService.getCompanyWithBillingPackage(user.customerCompanyId)
        .then(api._successLoadCompanyPlanInformation)
        .catch(api._errorLoadCompanyPlanInformation)
        .finally(api._finallyLoadCompanyPlanInformation)
    }

    function _successLoadCompanyPlanInformation (companyInfo) {
      $scope.companyPlan.id = companyInfo.billingPackage.planId
      $scope.companyPackage.id = companyInfo.billingPackage.plan.pricingPackageId

      api._setPlanRecommendations()

      if ($scope.data) {
        api._triggerViewSegmentEvent()
      }

      $scope.flags.loading = false
    }

    function _errorLoadCompanyPlanInformation (error) {
      ToastService.showErrorToast($translate.instant('somethingWentWrongTryAgainMsg'))
      console.error({ error })
    }

    function _finallyLoadCompanyPlanInformation () {
      $scope.flags.loading = false
    }
  }
})()
